<script setup lang="ts">
import { computed } from "vue";
import type { Field } from "@yawhub/core";
const props = defineProps<{ fields: Field[] }>();
const selected = defineModel<string[]>({ required: true });
const available = computed(() => props.fields.filter((f) => f.active));
</script>
<template>
  <details class="column-selection">
    <summary>
      Kolonner
      <span class="muted">{{ selected.length }} af {{ available.length }}</span>
    </summary>
    <div class="column-options">
      <div class="column-choice-actions">
        <button
          type="button"
          class="text-button"
          @click="selected = available.map((f) => f.id)"
        >
          Vælg alle</button
        ><button type="button" class="text-button" @click="selected = []">
          Fravælg alle
        </button>
      </div>
      <label v-for="f in available" :key="f.id" class="checkbox"
        ><input v-model="selected" type="checkbox" :value="f.id" />{{ f.label
        }}<span v-if="f.unit" class="muted">{{ f.unit }}</span></label
      >
    </div>
  </details>
</template>
<style
  scoped
  lang="scss"
  src="../styles/components/ColumnSelection.scss"
></style>
